import React, { useState, useEffect } from "react";
import axios from "axios";
import routes from "../../app/routes";
import DataTable from "react-data-table-component";
import CreateButton from "./ManagerCreateButton";
import ItemActions from "./TableItemActions";

import CellStringItemWithTooltip from "../ui/Table/CellStringItemWithTooltip";

export default function Table({
  showCreateButton,
  enterpriseId,
  teamId,
  roles,
}) {
  const [collection, setCollection] = useState();
  const [loaded, setLoaded] = useState(false);

  const [filteredFullName, setFilteredFullName] = useState("");
  const [filteredEnterprise, setFilteredEnterprise] = useState("");
  const [filteredRole, setFilteredRole] = useState("");

  const filteredItems =
    collection &&
    Object.values(collection).filter((item) => {
      let available = true;
      if (
        !(
          (item.attributes.full_name
            .toLowerCase()
            .includes(filteredFullName.toLowerCase()) ||
            item.attributes.email
              .toLowerCase()
              .includes(filteredFullName.toLowerCase())) &&
          item.attributes.enterprise
            .toLowerCase()
            .includes(filteredEnterprise.toLowerCase()) &&
          (item.attributes.user_role == filteredRole || filteredRole == "")
        )
      )
        available = false;

      return available;
    });

  let columns = [
    {
      name: "Full Name",
      selector: "attributes.full_name",
      sortable: true,
      cell: (row) => (
        <CellStringItemWithTooltip text={row.attributes.full_name} />
      ),
    },
    {
      name: "Permission Level",
      selector: "attributes.user_role",
      sortable: true,
    },
    {
      name: "Date Created",
      selector: "attributes.format_created_at",
      sortable: true,
      sortFunction: (a, b) =>
        a.attributes.created_at_int - b.attributes.created_at_int,
    },
    {
      name: "Email",
      selector: "attributes.email",
      sortable: true,
      cell: (row) => <div>{row.attributes.email}</div>,
    },
    {
      name: "Enterprise",
      selector: "attributes.enterprise",
      sortable: true,
    },
    {
      name: "Team",
      selector: "attributes.team",
      sortable: true,
      maxWidth: "200px",
      cell: (row) => <CellStringItemWithTooltip text={row.attributes.team} />,
    },
    {
      name: "Actions",
      width: "220px",
      cell: (row) => (
        <ItemActions
          row={row}
          updateCollection={updateCollection}
          teamId={teamId}
        />
      ),
      sortable: false,
    },
  ];

  if (enterpriseId != undefined) {
    columns = columns.filter((item) => item.name != "Enterprise");
  }

  const updateCollection = () => {
    setLoaded(true);
    axios
      .get(routes.api.team_leads.list, {
        params: { enterprise_id: enterpriseId, enterprise_team_id: teamId },
      })
      .then((resp) => {
        setCollection(resp.data.data);
        setLoaded(false);
      });
  };

  useEffect(() => {
    updateCollection();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <input
            type="text"
            className="form-control"
            placeholder="FULL NAME OR EMAIL"
            value={filteredFullName}
            onChange={(e) => setFilteredFullName(e.target.value)}
          />
        </div>
        {enterpriseId == undefined && (
          <div className="col-md-3">
            <input
              type="text"
              className="form-control"
              placeholder="ENTERPRISE"
              value={filteredEnterprise}
              onChange={(e) => setFilteredEnterprise(e.target.value)}
            />
          </div>
        )}
        {enterpriseId == undefined && (
          <div className="col-md-3">
            <select
              className="form-control"
              onChange={(e) => {
                setFilteredRole(e.target.value);
              }}
              value={filteredRole}
            >
              <option key="0" value="">
                Select Permission Level
              </option>
              {roles.map((item) => {
                return (
                  <option key={item.value} value={item.label}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        {showCreateButton && (
          <div
            className={`col-md-3 text-right ${
              enterpriseId == undefined ? "" : "col-md-offset-6"
            }`}
          >
            <CreateButton
              className="btn btn-primary"
              buttonName="Add Manager"
              onCreate={updateCollection}
              enterpriseId={enterpriseId}
              teamId={teamId}
              roles={roles}
            />
          </div>
        )}
      </div>
      {loaded && <p className="text-center mt20">Processing...</p>}
      {!loaded && (
        <div className="datatable-style">
          <DataTable
            title=""
            columns={columns}
            data={filteredItems}
            noDataComponent="No matching records found"
            persistTableHead={true}
            pagination
            paginationComponentOptions={{
              selectAllRowsItem: true,
              selectAllRowsItemText: "All",
            }}
          />
        </div>
      )}
    </>
  );
}
